import { YesNo } from '@hc-frontend/core-types';
import {
  getISODateTime,
  isoStringDateToDate,
} from '@hc-frontend/core-utils-date';

import { DobType, TobaccoType } from './constants';

export const currencyToNumber = (value: string): number => {
  if (!value) {
    return 0;
  }

  return Number(value.replace(/[^0-9.]/g, ''));
};

export const numberToCurrency = (value: number): string => {
  if (!value || isNaN(value)) {
    return '';
  }
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
};

export const mapTobaccoToLeadStorage = (
  value: TobaccoType | undefined,
): YesNo | undefined => {
  const map: Record<TobaccoType, YesNo> = {
    0: YesNo.Enum.n,
    1: YesNo.Enum.y,
  };

  return map[value as TobaccoType];
};

export const mapDobToLeadStorage = (
  value: DobType | undefined,
): string | undefined => {
  if (value === undefined) {
    return undefined;
  }

  return getISODateTime(isoStringDateToDate(value));
};
